import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowOutstanding } from "../../utils";

function RestrictOutStanding(props) {
  if (IsShowOutstanding()) return props.children;
  return <NotAccess />;
}

export default RestrictOutStanding;
